import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { CallSoundsState } from "@/store/call/sounds/types";
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: CallSoundsState = {
  sounds: [],
};


export const callSounds: Module<CallSoundsState,RootState> = {
  state,
  getters,
  actions,
  mutations
};